import React from 'react';

export interface DocumentContextValue {
  window: Window;
  document: Document;
  scrollElement: HTMLElement | Window; 
}

const DocumentContext = React.createContext<Partial<DocumentContextValue>>({ window, document, scrollElement: window });

export default DocumentContext;
